import { useState, useEffect, useCallback } from 'react'

const EXTRA_COLUMNS_KEY = 'ctrl+alt+g'

/**
 * Rapor ekranında ek alanları (localIp, detectedLocation, timezone vb.) göster/gizle.
 * Ctrl+Alt+G ile toggle. Varsayılan: gizli (sadece temel kolonlar).
 */
export default function useReportExtraColumns() {
  const [showExtra, setShowExtra] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(EXTRA_COLUMNS_KEY) ?? 'false')
    } catch {
      return false
    }
  })

  const toggle = useCallback(() => {
    setShowExtra((prev) => {
      const next = !prev
      try {
        localStorage.setItem(EXTRA_COLUMNS_KEY, JSON.stringify(next))
      } catch {}
      return next
    })
  }, [])

  useEffect(() => {
    const handler = (e) => {
      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === 'g') {
        e.preventDefault()
        toggle()
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [toggle])

  return [showExtra, setShowExtra, toggle]
}
